import axios from 'axios';
import { useUserStore } from '@/store/user';

const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;
const emailcontent  = "<script>alert('Email XSS')</script>";
const entityAddress = "<div onclick='alert(\"XSS\")'>Click me</div>";
const customcontent = "<span style='color:red'>This is red</span>";


export const SendOtp = (phone) => {
    return axios.post(apiUrl+"login/otp",{phone_booking_no: phone}).then((response) => response).catch(error => console.log(error));
};

export const VerifyOtp = (phone, otp)  => {
  const start = Date.now();
  ///console.log('start : ', start);
  const response = axios.post(apiUrl+'login/otp/validate', { phone_booking_no: phone, otp });
  ///console.log(`⏱ VerifyOtp API took ${Date.now() - start} ms`);
  return response;
}


export const GetBYBookings = (phone) => {
    const token = localStorage.getItem('authToken');
    //const userStore = useUserStore();
    //const token = userStore.authToken;
    return axios.post(apiUrl+"booking/bybooking-phone-no", { phone_booking_no: phone },
        { headers: { Authorization: `Bearer ${token}` }}
    ).then((response) => response).catch(error => console.log(error));
};

export const GetCompletedBYBookings = (phone) => {
    const token = localStorage.getItem('authToken');
    //const userStore = useUserStore();
    //const token = userStore.authToken;
    return axios.post(apiUrl+"booking/appointment-details", { booking_no: phone },
        { headers: { Authorization: `Bearer ${token}` }}
    ).then((response) => response).catch(error => console.log(error));
};

export const TokenRefresh = () => {
    const token = localStorage.getItem('authToken');
    //const userStore = useUserStore();
    //const token = userStore.authToken;
    return axios.post(apiUrl+"token/refresh",
        { headers: { Authorization: `Bearer ${token}` }}
    );
};

export const Logout = () => {
    //const token = localStorage.getItem('authToken');
    const userStore = useUserStore();
    const token = userStore.authToken;
    return axios.post(apiUrl+"logout",
        { headers: { Authorization: `Bearer ${token}` }}
    ).then((response) => response).catch(error => console.log(error));
};

export const PurposeSendOtp = (participant, phone, purpose, name, email) => {
    const userStore = useUserStore();
    const token = userStore.authToken;
    return axios.post(apiUrl+"otp/send-otp",
        {participant, phone, purpose, name, email},
        { headers: { Authorization: `Bearer ${token}` }}
    ).then((response) => response)
    .catch(error => console.log(error));
};

export function PurposeVerifyOtp(participant, purpose, otp) {
  const userStore = useUserStore();
  const token = userStore.authToken;
  return axios.post(apiUrl + 'otp/validate-otp', { participant, purpose, otp }, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(response => response)
    .catch(error => {
      console.error(error);
      return { data: { success: false, message: 'Request failed', verified: false } };
    });
}

export function PurposeCancelAllBookings(otp, booking_id) {
  const token = localStorage.getItem('authToken');
  return axios.post(apiUrl + 'response/booking/cancel', { otp, booking_id}, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(response => response)
    .catch(error => {
      console.error(error);
        return {
            data: {
            success: false,
            message: error?.response?.data?.message || 'Request failed',
            verified: false
            }
        };
    });
}


export function PurposeCancelSingleBookings(otp, applicant_id) {
  const token = localStorage.getItem('authToken');
  return axios.post(apiUrl + 'response/applicant/cancel', { otp, applicant_id}, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(response => response)
    .catch(error => {
      console.error(error);
        return {
            data: {
            success: false,
            message: error?.response?.data?.message || 'Request failed',
            verified: false
            }
        };
    });
}

export function ResheduleEntireBookings(booking_id, slot) {
  const token = localStorage.getItem('authToken');
  return axios.post(apiUrl + 'response/booking/reschedule', { booking_id, slot}, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(response => response)
    .catch(error => {
      console.error(error);
        return {
            data: {
            success: false,
            message: error?.response?.data?.message || 'Request failed',
            verified: false
            }
        };
    });
}

export function ResheduleSingleBookings(applicant_id,booking_id, slot) {
  const token = localStorage.getItem('authToken');
  return axios.post(apiUrl + 'response/applicant/reschedule', { applicant_id, booking_id, slot}, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(response => response)
    .catch(error => {
      console.error(error);
        return {
            data: {
            success: false,
            message: error?.response?.data?.message || 'Request failed',
            verified: false
            }
        };
  });
}

